import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { GroupModel } from "@core/models/groups.model";
import { RightModel } from "@core/models/rights.model";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GroupsService {
  constructor(private readonly http: HttpClient) {}

  getGroups$(): Observable<Array<GroupModel>> {
    return this.http.get<Array<GroupModel>>(`${environment.BASE_URL}group`);
  }

  getRights$(): Observable<Array<RightModel>> {
    return this.http.get<Array<RightModel>>(`${environment.BASE_URL}right`);
  }

  saveGroup$(
    data: Pick<GroupModel, "description" | "name"> & {
      rights: string[];
    }
  ): Observable<string> {
    const body = {
      description: data.description,
      name: data.name,
      rights: data.rights,
    };

    return this.http.post<string>(`${environment.BASE_URL}group`, body);
  }

  updateGroup$(
    data: Pick<GroupModel, "description" | "name" | "id" | "version"> & {
      rights: string[];
    }
  ): Observable<string> {
    const body = {
      description: data.description,
      name: data.name,
      rights: data.rights,
      version: data.version,
    };

    return this.http.put<string>(
      `${environment.BASE_URL}group/${data.id}`,
      body
    );
  }
}
